import View from '../common/View';
import Text from '../common/Text';
import Button from '../common/Button';
import BaseTemplate from '../components/BaseTemplate';
import { useLanguage } from '../hooks/useLanguage';
import './ChooseDestination.css';
import '../components/BaseTemplate.css';

const ChooseDestination = () => {
  const { t } = useLanguage();

  return (
    <BaseTemplate
      title={t('CHOOSE_DESTINATION_TITLE')}
      subtitle={t('CHOOSE_DESTINATION_SUBTITLE')}
    >
      <View className="destination-content">
        <Text variant="body" className="destination-description">
          {t('CHOOSE_DESTINATION_SUBTEXT')}
        </Text>

        <View className="destination-actions">
          <Button variant="primary" size="large">
            {t('CHOOSE_DESTINATION_TITLE')}
          </Button>
        </View>
      </View>
    </BaseTemplate>
  );
};

export default ChooseDestination;
